module.exports = __webpack_public_path__ + "media/images/common/akkodis-logo-for-black-bg-c612c8790c9fc2adcf044bbd63ca6953.svg";